/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Login_Resetpasswordtitle2Inputs */



/**

* @param {_Login_Resetpasswordtitle2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _login_resetpasswordtitle2 = /** @type {((inputs?: _Login_Resetpasswordtitle2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Login_Resetpasswordtitle2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Passwort zurücksetzen")
});
export { _login_resetpasswordtitle2 as "_login_resetPasswordTitle" }